// Initialize Sentry FIRST before any other imports
import '@/sentry';

// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/app/styles/global.scss';
import { App } from '@/App';
import { BrowserRouter } from 'react-router-dom';

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>

  // </StrictMode>,
);
